import moment from "moment";
import { DEFAULT_MOMENT_LOCALE } from "../../../i18n/helpers";
import { DateFormat } from "../../../modules/constants";

//Constants
const SET_LAST_ENTRY_DATE = "SET_LAST_ENTRY_DATE";
const SET_START_DATE = "SET_START_DATE";
const SET_END_DATE = "SET_END_DATE";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

//Acessors
const getLastEntryDate = (state) => state?.lastEntryDate;
const getStartDate = (state) => state?.startDate;
const getEndDate = (state) => state?.endDate;
const getFormattedDateRange = (state) => state?.formattedDateRange;

//Default State
const defaultState = {
  lastEntryDate: null,
  startDate: null,
  endDate: null,
  formattedDateRange: {},
};

//State & Actions
export const studyEntriesDatePickerReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_LAST_ENTRY_DATE: {
      const { lastEntryDate } = action;

      if (lastEntryDate) {
        return Object.assign({}, state, {
          lastEntryDate: lastEntryDate,
          startDate: moment(moment(lastEntryDate).subtract(6, "days").toDate())
            .startOf("day")
            .toDate(),
          endDate: moment(lastEntryDate).endOf("day").toDate(),
          formattedDateRange: {
            startDate: moment(
              moment(lastEntryDate).subtract(6, "days").toDate()
            )
              .startOf("day")
              .locale(DEFAULT_MOMENT_LOCALE)
              .format(DateFormat.START_DATE),
            endDate: moment(lastEntryDate)
              .endOf("day")
              .locale(DEFAULT_MOMENT_LOCALE)
              .format(DateFormat.END_DATE),
          },
        });
      }
      return defaultState;
    }
    case SET_START_DATE: {
      let { startDate } = action;
      return {
        ...state,
        startDate: startDate,
        formattedDateRange: {
          ...state.formattedDateRange,
          startDate: moment(startDate)
            .locale(DEFAULT_MOMENT_LOCALE)
            .format(DateFormat.START_DATE),
        },
      };
    }
    case SET_END_DATE: {
      let { endDate } = action;
      return {
        ...state,
        endDate: endDate,
        formattedDateRange: {
          ...state.formattedDateRange,
          endDate: moment(endDate)
            .locale(DEFAULT_MOMENT_LOCALE)
            .format(DateFormat.END_DATE),
        },
      };
    }
    case RESET_STATE:
      return defaultState;
    case LOGOUT:
      return defaultState;
    default:
      return state;
  }
};

//Action Creators
const fetchLastEntryDate = () => (dispatch) => {
  dispatch({
    type: SET_LAST_ENTRY_DATE,
    lastEntryDate: moment().toISOString(),
  });
};

const setStartDate = (date) => (dispatch) => {
  dispatch({ type: SET_START_DATE, startDate: date });
};

const setEndDate = (date) => (dispatch) => {
  dispatch({ type: SET_END_DATE, endDate: date });
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

// Maps
export const mapStateToProps = (state) => {
  return {
    lastEntryDate: getLastEntryDate(state),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    formattedDateRange: getFormattedDateRange(state),
  };
};

export const mapDispatchToProps = {
  fetchLastEntryDate,
  setStartDate,
  setEndDate,
  resetState,
};
